import CommonDialog, { CommonDialogProps } from '@/../../common/src/components/CommonDialog';
import { useEffect, useState } from 'react';

// 全局弹窗组件 目前仅支持单个弹窗。
function GlobalDialog() {
  const [props, setProps] = useState<CommonDialogProps>({});

  useEffect(() => {
    window.showGlobalDialog = (dialogProps: CommonDialogProps) => {
      setProps({
        ...dialogProps,
        visible: true,
        onCancel: (e) => {
          setProps({
            ...dialogProps,
            visible: false,
          });
          dialogProps.onCancel?.(e);
        },
        onConfirm: async (e) => {
          dialogProps.onConfirm && (await dialogProps.onConfirm?.(e));
          setProps({
            ...dialogProps,
            visible: false,
          });
        },
        onClose: () => {
          setProps({
            ...dialogProps,
            visible: false,
          });
          dialogProps.onClose?.();
        },
      });
    };
    return () => {
      window.showGlobalDialog = undefined;
    };
  }, []);

  return <CommonDialog {...props} />;
}

export default GlobalDialog;
